var exports = {
  "p$": "slideIndicator-MWN2M",
  "kb": "left-MWN2M",
  "yo": "hovered-MWN2M",
  "OU": "captionWrapper-MWN2M",
  "pG": "caption-MWN2M",
  "BJ": "subslides-MWN2M",
  "q3": "indicator-MWN2M",
  "Om": "dot-MWN2M",
  "vu": "active-MWN2M",
};

module.exports = exports;
